import axios, { AxiosResponse } from 'axios';
import { prop } from 'ramda';
import BaseFormatter from './format';
import { pick } from './path';

const LOCALE_KEY_DEFAULT = 'de';
export const LOCALE_KEY = getLocaleKey();
export const DATA = loadData(LOCALE_KEY);
export const TRANSLATIONS = DATA.then(prop('translations'));

const formatter = new BaseFormatter();

export function format(k: string, values?: any): string {
    return formatter.interpolate(k, values);
}

export function translate(k: string): Promise<string> {
    return TRANSLATIONS.then(t => pick(k, t));
}

function getLocaleKey(): string {
    // ssr fallback
    if (typeof window === 'undefined') {
        return LOCALE_KEY_DEFAULT;
    }

    const pathParts = window.location.pathname.split('/').filter(Boolean);

    // checks for locale patterns as "de", "nl", "en-gb"
    const localePattern = /^[a-z]{2}(-[a-z]{2})?$/i;
    for (const part of pathParts) {
        if (localePattern.test(part)) {
            return part;
        }
    }

    return LOCALE_KEY_DEFAULT;
}

function loadData(locale: string): Promise<AxiosResponse> {
    return axios.get(`/${locale}/i18n.json?v=${app.version}`)
        .then(prop('data'));
}
